/**
 * Generic message types and schemas for providers without specific type definitions
 */

import { z } from "zod";
import { MessageBaseSchema } from "../message";

// ============================================================================
// GENERIC MESSAGE METADATA SCHEMAS
// ============================================================================

/**
 * Generic message metadata
 * Flexible metadata for providers without specific type definitions
 */
export const GenericMessageMetadataSchema = z.record(z.string(), z.any());

export type GenericMessageMetadata = z.infer<typeof GenericMessageMetadataSchema>;

// ============================================================================
// GENERIC MESSAGE SCHEMAS
// ============================================================================

/**
 * Generic message schema
 * Represents a message from a provider without specific type definitions
 */
export const GenericMessageSchema = MessageBaseSchema.extend({
  // Discriminator can be any string for generic providers
  provider: z.string(),
  metadata: GenericMessageMetadataSchema.optional(),
}).passthrough();

export type GenericMessage = z.infer<typeof GenericMessageSchema>;

// ============================================================================
// HELPERS
// ============================================================================

/**
 * Type guard to check if a message is a generic message
 */
export function isGenericMessage(message: any): message is GenericMessage {
  return (
    message?.provider &&
    message.provider !== "slack-oauth" &&
    message.provider !== "outlook-oauth" &&
    message.provider !== "google-mail"
  );
}
